import type { IDocumentInfo } from './IDocumentInfo';
export class DocumentInfo implements IDocumentInfo {
    id: IDocumentInfo['id'];
    name: IDocumentInfo['name'];
    contentString: IDocumentInfo['contentString'];
    mimeType: IDocumentInfo['mimeType'];
    public static parseObject(obj: IDocumentInfo): DocumentInfo {
        try {
            return new DocumentInfo(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Document Info object : ${JSON.stringify(obj)}`,
            );
        }
    }
    public static empty() {
        return DocumentInfo.parseObject({
            id: '',
            name: '',
            contentString: '',
            mimeType: '',
        });
    }
    constructor(props: IDocumentInfo) {
        this.id = props.id;
        this.name = props.name;
        this.contentString = props.contentString;
        this.mimeType = props.mimeType;
    }
}
